<div>
  <div class="app__itemCard w-full h-auto justify-start p-0 text-base">
    <div class="flex justify-between items-center p-4 border-b">
      <p class="app__text-higlight flex text-[#1E1E20] text-base m-0 font-semibold">
        {{ data?.title || 'Select User To Sync With' }}
      </p>
      <span class="material-icons search-icon text-k-black font-bold cursor-pointer text-base" (click)="closeDialog()"> close </span>
    </div>

    <div class="p-4 relative">
      <!-- Search Input -->
      <div
        [class]="
          searchResults.length < 1
            ? 'search-wrapper p-3 rounded-lg border border-border-gray shadow-sm flex justify-between items-center'
            : 'search-wrapper p-3 rounded-lg border border-border-gray shadow-sm flex justify-between items-center rounded-b-none'
        "
      >
        <span class="material-icons search-icon text-k-blue text-base cursor-pointer"> search </span>
        <input
          type="text"
          [placeholder]="data?.placeholderText || 'Search Connections'"
          class="w-full border-none outline-none text-[#53565B66]"
          (input)="handleRelationshipSearch($event.target.value)"
          [formControl]="userInput"
        />
      </div>

      <!-- Search Results -->
      @if (searchResults.length > 0 && search_val) {
      <div class="search-results-dropdown border border-t-0 border-border-gray rounded-b-lg shadow-sm max-h-[300px] overflow-y-auto">
        @for (user of searchResults; track user.user_id) {
        <div
          class="flex items-center gap-2 hover:bg-[#EBF0FA] cursor-pointer p-4 border-b last:border-b-0"
          (click)="selectUser(user)"
        >
          <ngx-avatars
            size="32"
            [src]="user?.user_profile_image_url"
            [name]="user?.user_first_name + ' ' + user?.user_last_name"
            [round]="false"
            initialsSize="2"
            cornerRadius="100"
          ></ngx-avatars>
          <div class="flex items-start flex-col">
            <p class="m-0 font-semibold text-xs">{{ user?.user_first_name + ' ' + user?.user_last_name | titlecase | truncateStrPipe : 28 }}</p>
            <span class="text-[#898F9E] text-[10px] font-medium"> {{ user?.user_state }} </span>
          </div>
        </div>
        }
      </div>
      }

      <!-- No Results -->
      @if (!isLoading && searchResults.length == 0 && search_val) {
      <div class="flex gap-3 items-center p-4 border border-t-0 border-border-gray rounded-b-lg">
        <p class="m-0 text-k-blue">No User Found</p>
      </div>
      }

      <!-- Loading -->
      @if (isLoading) {
      <div class="h-full w-full loader-option overflow-hidden border border-t-0 border-border-gray rounded-b-lg">
        <div class="search-box-container w-full">
          <div class="loader-container grid grid-cols-1 p-0">
            @for (item of ['1', '2', '3']; track item) {
            <div class="w-full h-[70px]">
              <div class="ph-item w-full content__loader h-full" style="padding: 0px; margin: 0px; border: none">
                <div class="ph-col-12 h-full" style="padding: 0px !important; margin: 0px">
                  <div class="ph-row h-full">
                    <div class="ph-col-12 h-[90%]"></div>
                  </div>
                </div>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      }

      <!-- Selected User Display / No User Selected -->
      @if (!isLoading && !search_val) {
      <div class="mt-4">
        @if (selectedUser) {
        <div class="flex items-center justify-between gap-2 rounded-lg px-4 py-3 border border-[#D3DCE8] bg-white">
          <div class="flex gap-3 items-center">
            <ngx-avatars
              size="40"
              [src]="selectedUser?.user_profile_image_url"
              [name]="selectedUser?.user_first_name + ' ' + selectedUser?.user_last_name"
              [round]="false"
              initialsSize="2"
              cornerRadius="100"
            ></ngx-avatars>
            <div class="flex items-start flex-col">
              <p class="m-0 font-semibold text-sm">{{ selectedUser?.user_first_name + ' ' + selectedUser?.user_last_name | titlecase }}</p>
              <span class="text-[#898F9E] text-xs font-medium"> {{ selectedUser?.relationship_name || 'User' }} </span>
            </div>
          </div>
          <button 
            class="flex items-center justify-center rounded-full w-[32px] h-[32px] bg-[#EBF0FA] hover:bg-[#EBF0FA]" 
            (click)="clearUser()"
          >
            <span class="material-icons text-[#25508E] text-base">remove_circle_outline</span>
          </button>
        </div>
        } @else {
        <div class="flex items-center justify-center gap-3 rounded-lg px-4 py-3 border border-[#D3DCE8] bg-[#F9FAFB]">
          <div class="flex items-center justify-center w-[24px] h-[24px]">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clip-path="url(#clip0_1133_150931)">
                  <path d="M11.2037 12.7994C9.93696 12.8001 8.69849 12.425 7.64504 11.7215C6.59159 11.0181 5.77052 10.0179 5.28576 8.84757C4.801 7.67726 4.67434 6.38943 4.92182 5.1471C5.1693 3.90477 5.77978 2.76379 6.676 1.86857C7.57223 0.973351 8.71389 0.364144 9.9565 0.118057C11.1991 -0.128029 12.4868 6.91791e-05 13.6566 0.486138C14.8263 0.972206 15.8256 1.79439 16.5279 2.84863C17.2302 3.90287 17.6039 5.14176 17.6018 6.4085C17.598 8.10356 16.9225 9.728 15.7232 10.9259C14.524 12.1238 12.8988 12.7975 11.2037 12.7994Z" fill="#004DE5"/>
                  <path d="M23.0124 21.433C23.035 21.7755 22.9842 22.1189 22.8635 22.4402C22.7428 22.7615 22.5549 23.0533 22.3124 23.2961C22.0699 23.539 21.7783 23.7273 21.4572 23.8485C21.1361 23.9696 20.7928 24.0209 20.4503 23.9987H2.55851C2.2163 24.0203 1.87341 23.9687 1.55272 23.8473C1.23203 23.7259 0.940916 23.5375 0.698791 23.2947C0.456665 23.0519 0.269096 22.7603 0.148596 22.4393C0.0280965 22.1182 -0.0225644 21.7752 -7.14138e-06 21.433C-0.0521191 20.4179 -0.00176764 19.4001 0.150284 18.395C0.403293 16.9892 0.997191 15.667 1.87994 14.544C2.76269 13.4211 3.90736 12.5318 5.21365 11.954C5.25643 11.9228 5.30955 11.9091 5.36211 11.9157C5.41466 11.9224 5.46269 11.9489 5.49634 11.9898C6.84945 13.373 8.65906 14.2174 10.5883 14.3658C10.6527 14.3658 10.7172 14.3873 10.803 14.4016H12.2057C12.2916 14.4016 12.3525 14.373 12.4169 14.3658C14.3542 14.2259 16.1737 13.3835 17.5339 11.9969C17.5676 11.956 17.6156 11.9295 17.6681 11.9229C17.7207 11.9162 17.7738 11.9299 17.8166 11.9611C19.1228 12.5395 20.2676 13.4289 21.1509 14.5517C22.0341 15.6745 22.629 16.9965 22.8835 18.4022C23.028 19.4056 23.0711 20.421 23.0124 21.433Z" fill="#B0C4EF"/>
                </g>
                <defs>
                  <clipPath id="clip0_1133_150931">
                    <rect width="23.016" height="24" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
          </div>
          <div class="flex items-start flex-col">
            <p class="m-0 font-[600] text-[12px] text-[#1E1E20]">No  <span class="text-[#25508E] text-[12px] font-bold">User</span> Selected</p>
           
          </div>
        </div>
        }
      </div>
      }
    </div>

    <!-- Footer with Save Button (Always Visible) -->
    <hr class="m-0" />
    <div class="flex items-center gap-2 text-base justify-end px-4 py-3">
      <button
        [class]="selectedUser ? 'app__btn--primary w-fit m-0 mt-0 px-6' : 'app__btn--disabled w-fit m-0 mt-0 px-6'"
        [disabled]="!selectedUser"
        (click)="saveSelection()"
      >
        Save
      </button>
    </div>
  </div>
</div>

